import { render, staticRenderFns } from "./MainOnboardingComponent.vue?vue&type=template&id=305a0291&scoped=true"
import script from "./MainOnboardingComponent.vue?vue&type=script&lang=js"
export * from "./MainOnboardingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305a0291",
  null
  
)

export default component.exports